import React, { useEffect, useState } from "react";
import "./prices.css";
import { Button } from "@material-ui/core";
import axios from "axios";
import Swal from "sweetalert2";
import { useContext } from "react";
import { Context } from "../../../context/Context";
const Prices = ({ arriveData }) => {
  const [pricesData, setPricesData] = useState([]);
  const { user, token } = useContext(Context);
  useEffect(() => {
    if (arriveData) {
      const getMonths = async () => {
        const monthIndex = arriveData.slice(5, 7);
        try {
          const months = await axios.get(
            "https://www.rezerwacjaparkingu.com/backend_artlot/api/months"
          );
          const month = months.data.filter((m) => m.id === monthIndex);
          setPricesData(month);
        } catch (err) {
          console.log(err);
        }
      };
      getMonths();
    }
  }, [arriveData]);

  const handleChangePrices = () => {
    Swal.fire({
      title: "Edytuj ceny",
      html: `
      <div style="display: flex; align-items: center; justify-content: center">
      <span>1 dzień: </span>
      <input type="number" id="firstDay" class="swal2-input" value=${pricesData?.[0]?.firstDay}>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
      <p>2 dni: </p>
      <input type="number" id="secondDay" class="swal2-input" value=${pricesData?.[0]?.secondDay}>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
      <span>3 dni: </span>
      <input type="number" id="thirdDay" class="swal2-input" value=${pricesData?.[0]?.thirdDay}>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
      <span>4 dni: </span>
      <input type="number" id="fourthDay" class="swal2-input" value=${pricesData?.[0]?.fourthDay}>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
      <span>5 dni: </span>
      <input type="number" id="fifthDay" class="swal2-input" value=${pricesData?.[0]?.fifthDay}>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
      <span>6 dni: </span>
      <input type="number" id="sixthDay" class="swal2-input" value=${pricesData?.[0]?.sixthDay}>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
      <span>7 dni: </span>
      <input type="number" id="seventhDay" class="swal2-input" value=${pricesData?.[0]?.seventhDay}>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
      <span>8 dni: </span>
      <input type="number" id="eighthDay" class="swal2-input" value=${pricesData?.[0]?.eighthDay}>
      </div>
      <div style="display: flex; align-items: center; justify-content: center">
      <span>następne dni: </span>
      <input type="number" id="nextDay" class="swal2-input" value=${pricesData?.[0]?.nextDay}>
      </div>

      `,
      confirmButtonText: "Zmień ceny",
      confirmButtonColor: "#1267a2",
      focusConfirm: false,
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: "Anuluj",
      preConfirm: () => {
        const firstDay = Swal.getPopup().querySelector("#firstDay").value;
        const secondDay = Swal.getPopup().querySelector("#secondDay").value;
        const thirdDay = Swal.getPopup().querySelector("#thirdDay").value;
        const fourthDay = Swal.getPopup().querySelector("#fourthDay").value;
        const fifthDay = Swal.getPopup().querySelector("#fifthDay").value;
        const sixthDay = Swal.getPopup().querySelector("#sixthDay").value;
        const seventhDay = Swal.getPopup().querySelector("#seventhDay").value;
        const eighthDay = Swal.getPopup().querySelector("#eighthDay").value;
        const nextDay = Swal.getPopup().querySelector("#nextDay").value;
        if (!firstDay || !secondDay || !thirdDay || !fourthDay) {
          Swal.showValidationMessage(`Wypełnij wszystkie pola`);
        }
        return {
          firstDay: parseInt(firstDay),
          secondDay: parseInt(secondDay),
          thirdDay: parseInt(thirdDay),
          fourthDay: parseInt(fourthDay),
          fifthDay: parseInt(fifthDay),
          sixthDay: parseInt(sixthDay),
          seventhDay: parseInt(seventhDay),
          eighthDay: parseInt(eighthDay),
          nextDay: parseInt(nextDay),
        };
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          const {
            firstDay,
            secondDay,
            thirdDay,
            fourthDay,
            fifthDay,
            sixthDay,
            seventhDay,
            eighthDay,
            nextDay,
          } = result.value;
          const changedData = {
            firstDay,
            secondDay,
            thirdDay,
            fourthDay,
            fifthDay,
            sixthDay,
            seventhDay,
            eighthDay,
            nextDay,
          };
          const change = async () => {
            await axios.put(
              `https://www.rezerwacjaparkingu.com/backend_artlot/api/months/${pricesData?.[0]?._id}`,
              changedData,
              {
                headers: {
                  authorization: "megaparkingIGHERQHIGQRE " + token,
                },
              }
            );
          };
          change();
          Swal.fire({
            icon: "success",
            title: "Zapisano",
            confirmButtonText: `Ok`,
            confirmButtonColor: "#1267a2",
            denyButtonColor: "gray",
          }).then(() => {
            window.location.reload();
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Coś poszło nie tak",
          confirmButtonText: `Ok`,
          confirmButtonColor: "#1267a2",
          denyButtonColor: "gray",
        });
      });
  };

  return (
    <div className="Prices">
      <div className="wrapper">
        <div className="prices">
          <Button
            variant="contained"
            className="button"
            color="primary"
            size="small"
          >
            CENA PARKINGU ZA {pricesData?.[0]?.nazwa}
          </Button>
          <ul>
            <li>
              1 DZIEŃ: <span>{pricesData?.[0]?.firstDay} zł</span>
            </li>
            <li>
              2 DNI: <span> {pricesData?.[0]?.secondDay}zł</span>
            </li>
            <li>
              3 DNI: <span>{pricesData?.[0]?.thirdDay} zł</span>
            </li>
            <li>
              4 DNI: <span>{pricesData?.[0]?.fourthDay} zł</span>
            </li>
            <li>
              5 DNI: <span>{pricesData?.[0]?.fifthDay} zł</span>
            </li>
            <li>
              6 DNI: <span>{pricesData?.[0]?.sixthDay} zł</span>
            </li>
            <li>
              7 DNI: <span>{pricesData?.[0]?.seventhDay} zł</span>
            </li>
            <li>
              8 DNI: <span>{pricesData?.[0]?.eighthDay} zł</span>
            </li>
            <li>
              KOLEJNE DOBY: <span>{pricesData?.[0]?.nextDay} zł</span>
            </li>
          </ul>
        </div>
        {user ? (
          <p className="priceChangeElement" onClick={handleChangePrices}>
            Zmień ceny
          </p>
        ) : undefined}
      </div>
    </div>
  );
};

export default Prices;
